require('features/articleSearchBox');
require('features/segment');
require('features/googleAnalytics4');
require('features/routing');
require('features/articleSearchResultsFacets');

require('libraries/appNexus');

require('./routing/pageUrl');

require('./components/pagination/paginationToggle');
require('./components/pagination/paginationHandler');
require('./components/articleCardsHandler');
require('./components/articleCardSkeletonHandler');
require('./components/canonicalHandler');

require('../learningCenter/articlePage/components/listingCounts');
require('../learningCenter/articlePage/components/submitSearchHandler');
require('../blog/articlePage/components/typeahead');

require('./components/eventTracking/googleAnalytics4EventsHandler');
require('./components/eventTracking/segmentEventsHandler');
